import { db } from '@/core/db/dexie'
import type { DraftParteDiaria } from '@/core/db/entities'
import { migrarEstado, type ParteDiariaState } from './parteDiariaStore'

/**
 * Rascunhos de parte diária (mesmo desenho de draftCarreteiroRepo): N em
 * paralelo, persistidos no Dexie, apagados quando vão para o outbox.
 */

export async function upsertDraft(state: ParteDiariaState): Promise<void> {
  if (state.mveId == null) return // ainda não escolheu equipamento — não persiste lixo
  const draft: DraftParteDiaria = {
    id: state.id,
    modulo: state.modulo,
    mveId: state.mveId,
    mvePrefixo: state.mvePrefixo,
    dt: state.dt,
    linhasCount: state.modulo === 'EPP' ? (state.epp.dtInicial ? 1 : 0) : state.linhas.length,
    lastUpdatedAt: Date.now(),
    state: JSON.stringify(state),
  }
  await db.draft_parte_diaria.put(draft)
}

export async function loadDraft(id: string): Promise<ParteDiariaState | null> {
  const row = await db.draft_parte_diaria.get(id)
  if (!row) return null
  try {
    return migrarEstado(JSON.parse(row.state))
  } catch (e) {
    console.warn('[draftParteDiariaRepo] falha ao parsear draft', id, e)
    return null
  }
}

export async function listDrafts(): Promise<DraftParteDiaria[]> {
  const all = await db.draft_parte_diaria.toArray()
  return all.sort((a, b) => b.lastUpdatedAt - a.lastUpdatedAt)
}

export async function deleteDraft(id: string): Promise<void> {
  await db.draft_parte_diaria.delete(id)
}

let autoSaveBootstrapped = false
/** Auto-save debounced (700ms) do estado do store. Idempotente. */
export function bootstrapAutoSaveParteDiaria(store: {
  subscribe: (cb: () => void) => () => void
  getState: () => ParteDiariaState
}): void {
  if (autoSaveBootstrapped) return
  autoSaveBootstrapped = true
  let timer: ReturnType<typeof setTimeout> | null = null
  store.subscribe(() => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      timer = null
      upsertDraft(store.getState()).catch((e) => console.warn('[draftParteDiariaRepo] auto-save falhou', e))
    }, 700)
  })
}
